import React, {useEffect} from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import Tooltip from '@mui/material/Tooltip';
import Grid from '@mui/material/Grid';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '../../../../redux/store';
import {searchBooks} from '../../../../redux/slices/booksSlice';
import {getAffiliateCode} from '../../../../redux/slices/userSlice';
import useForm, {FormDataType} from '../../../../hooks/useForm';
import ButtonStyle from '../../../../styles/buttonStyle/buttonStyle';

const SearchBook = () => {
  const dispatch = useDispatch<AppDispatch>();
  // idealmente modificar el lugar de llamada del getAffiliateCode
  // para que no este llamandolo cada vez que entra el home
  useEffect(() => {
    void dispatch(getAffiliateCode());
  }, [dispatch]);

  const {handleInputChange, handleSubmit} = useForm(
    {
      keyword: ' ',
    },
    ({keyword}: FormDataType) =>
      void dispatch(searchBooks({keyword: keyword.trim()})),
  );

  // const {keyword} = formData;

  return (
    <form onSubmit={handleSubmit}>
      <Grid
        height="10vh"
        display="flex"
        justifyContent="center"
        alignItems="center">
        <Grid width="80vw">
          <TextField
            type="text"
            name="keyword"
            onChange={handleInputChange}
            variant="outlined"
            fullWidth
            label="Search by Title, author name, ISBN-13"
            size="small"
          />
        </Grid>
        <Grid width="5vw">
          <ButtonStyle>
            <Tooltip title="Search">
              <Button type="submit" variant="outlined" size="medium">
                <SearchIcon />
              </Button>
            </Tooltip>
          </ButtonStyle>
        </Grid>
      </Grid>
    </form>
  );
};

export default SearchBook;
